// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-n_fv","advertDetailContactItem__link":"c-n_fw"};